import { Loading } from 'components';
import { ChamadoSemLogin as ChamadoSemLoginView } from './components/ChamadoSemLogin';
import { useChamadoSemLogin } from './hooks/useChamadoSemLogin';

export const ChamadoSemLogin = () => {
  const { isLoading, ...viewProps } = useChamadoSemLogin();

  return (
    <>
      {isLoading && <Loading />}
      <ChamadoSemLoginView {...viewProps} />
    </>
  );
};

export default ChamadoSemLogin;
